<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-toolbar flat outlined>
            <v-btn icon :link="false" @click="back">
                <v-icon>fa-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title>Editar Colaborador</v-toolbar-title>
            <v-spacer/>
            <v-btn color="primary" @click="send_form">
              Guardar
            </v-btn>
  </v-toolbar>
    <v-container grid-list-md fluid>
      <v-alert
        :value="alertDialog"
        :type="alertDialogType"
        outline
      >
        {{ alertDialogMessage }}
      </v-alert>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Datos Personales</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm3 md3 style="display: none">
                <v-text-field
                  disabled
                  v-model="colaborador_id"
                  label="id"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="primer_nombre"
                  label="Nombre(s)"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="primer_apellido"
                  label="Primer Apellido"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="segundo_apellido"
                  label="Segundo Apellido"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-select
                  v-model="sexo"
                  label="Sexo"
                  :items="tipo_sexo"
                />
              </v-flex>
              <FechaPicker v-model="fecha_nacimiento" label="Fecha Nacimiento"></FechaPicker>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="nacionalidad"
                  label="Nacionalidad"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="originario"
                  label="Originario"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="curp"
                  label="CURP"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="estado_civil"
                  label="Estado Civil"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="rfc"
                  label="RFC"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="nss"
                  label="Núm. SS"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="domicilio"
                  label="Domicilio"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="colonia"
                  label="Colonia"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="ciudad"
                  label="Localidad"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="estado"
                  label="Estado"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="codigo_postal"
                  label="Código Postal"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="telefono"
                  label="Teléfono"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="celular"
                  label="Celular"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Datos Empresa</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  v-model="numero_empleado"
                  label="Núm. Empleado"
                />
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  v-model="credencial"
                  label="Credencial"
                />
              </v-flex>
              <FechaPicker v-model="vigencia_credencial" label="Vigencia Credencial"></FechaPicker>
              <v-flex xs12 sm4 md4>
                <v-select
                  v-model="status"
                  label="Estatus"
                  :items="tipo_status"
                  @change="tipo_status_change($event)"
                />
              </v-flex>
              <v-flex xs12 sm8 md8>
                <v-textarea
                  v-model="motivo"
                  :value="motivo"
                  :disabled="motivo_disabled"
                  label="Motivo"
                  no-resize
                  rows="1"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-select
                  v-model="empresa"
                  label="Empresa"
                  :items="empresas"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="email"
                  label="Correo Electrónico"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="grupo"
                  label="Grupo"
                />
              </v-flex>
              <FechaPicker v-model="fecha_contratacion" label="Fecha Contratación"></FechaPicker>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="gerencia"
                  label="Gerencia"
                />
              </v-flex>
              <FechaPicker v-model="gerencia_desde" label="Fecha Gerencia Desde"></FechaPicker>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="frente"
                  label="Frente"
                />
              </v-flex>
              <FechaPicker v-model="frente_desde" label="Frente desde"></FechaPicker>
              <v-flex xs12 sm3 md3 v-if="empresa ==='XSP'">
                <v-select
                  v-model="puesto"
                  label="Puesto"
                  :items="puestos_xsp"
                />
              </v-flex>
              <v-flex xs12 sm3 md3 v-else>
                <v-text-field
                  v-model="puesto"
                  label="Puesto"
                />
              </v-flex>
              <FechaPicker v-model="puesto_desde" label="Puesto Desde"></FechaPicker>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="periodo_pago"
                  label="Periodo Pago"
                />
              </v-flex>
              <FechaPicker v-model="periodo_pago_desde" label="Periodo Pago Desde"></FechaPicker>
              <v-flex xs12 sm12 md12>
                <v-textarea
                  v-model="observaciones"
                  label="Observaciones"
                  no-resize
                  rows="3"
                  :value="observaciones"
                />
              </v-flex>
            </v-layout>
            <HorariosColaboradores v-model="colaborator_hours"></HorariosColaboradores>
            <camera v-model="captures"></camera>
            <signature v-model="signatures"></signature>
            <biomini v-model="fingerPrint"></biomini>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import Biomini from '@/components/biomini.vue';
import Camera from '@/components/camera.vue';
import HorariosColaboradores from '@/components/horarios_colaboradores.vue';
import Signature from '@/components/signature.vue';
import FechaPicker from '@/components/fecha_picker.vue';
import colaboratorHours from '@/mixins/colaborator_hours';

export default {
  components: {
    Signature,
    HorariosColaboradores,
    Camera,
    Biomini,
    FechaPicker,
  },
  mixins: [colaboratorHours],
  data: () => ({
    colaborador_info: {},
    fingerPrint: {
      fingerprint_image: '',
      fingerprint_template: '',
    },
    totalItems: 0,
    colaboradores: [],
    pagination: {},
    timer: '',
    search: null,
    presearch: null,
    searchTimer: null,
    infodialog: false,
    headers: [
      { text: 'Núm. Empleado', value: 'numero_empleado', sortable: true },
      { text: 'Credencial', value: 'credencial', sortable: true },
      { text: 'Nombre(s)', value: 'primer_nombre', sortable: true },
      { text: 'Primer Apellido', value: 'primer_apellido', sortable: true },
      { text: 'Segundo Apellido', value: 'segundo_apellido', sortable: true },
      { text: 'Empresa', value: 'empresa', sortable: true },
      { text: 'Gerencia', value: 'gerencia', sortable: true },
      { text: 'Estatus', value: 'status', sortable: true },
      { text: 'Acciones', value: 'acciones', sortable: false },
    ],
    tipo_status: [
      { text: 'Inactivo', value: 'inactivo' },
      { text: 'Activo', value: 'activo' },
      { text: 'Baja', value: 'baja' },
      { text: 'En Capacitación', value: 'capacitacion' },
    ],
    tipo_sexo: [
      { text: 'Masculino', value: 'M' },
      { text: 'Femenino', value: 'F' },
    ],
    empresas: [
      { text: 'AEROPREMIER', value: 'AEROPREMIER' },
      { text: 'CADDY', value: 'CADDY' },
      { text: 'CONSTRUYENDO Y CRECIENDO', value: 'CONSTRUYENDO Y CRECIENDO' },
      { text: 'DRELEX', value: 'DRELEX' },
      { text: 'EKO', value: 'EKO' },
      { text: 'FYCC', value: 'FYCC' },
      { text: 'ICH', value: 'ICH' },
      { text: 'INMOBILIA', value: 'INMOBILIA' },
      { text: 'KIWI', value: 'KIWI' },
      { text: 'MIT', value: 'MIT' },
      { text: 'PROVEEDOR', value: 'PROVEEDOR' },
      { text: 'RAPP', value: 'RAPP' },
      { text: 'SEG', value: 'SEG' },
      { text: 'WALLGROW', value: 'WALLGROW' },
      { text: 'XSP', value: 'XSP' },
      { text: 'YCC', value: 'YCC' },
      { text: 'KAAB', value: 'KAAB' },
    ],
    puestos_xsp: [
      { text: 'ANALISTA DE PROCESOS', value: 'ANALISTA DE PROCESOS' },
      { text: 'AUXILIAR RECURSOS HUMANOS', value: 'AUXILIAR RECURSOS HUMANOS' },
      { text: 'COORDINADOR', value: 'COORDINADOR' },
      { text: 'COORDINADOR ADMINISTRATIVO', value: 'COORDINADOR ADMINISTRATIVO' },
      { text: 'COORDINADOR DE MONITOREO', value: 'COORDINADOR DE MONITOREO' },
      { text: 'COORDINADOR INMOBILIA', value: 'COORDINADOR INMOBILIA' },
      { text: 'COORDINADOR OPERATIVO YCC', value: 'COORDINADOR OPERATIVO YCC' },
      { text: 'COORDINADOR RH', value: 'COORDINADOR RH' },
      { text: 'GERENTE DE OPERACIONES', value: 'GERENTE DE OPERACIONES' },
      { text: 'GUARDIA DE SEGURIDAD', value: 'GUARDIA DE SEGURIDAD' },
      { text: 'MONITORISTA', value: 'MONITORISTA' },
      { text: 'PATRULLERO', value: 'RECEPCIONISTA' },
      { text: 'PERSONAL DE LIMPIEZA', value: 'PERSONAL DE LIMPIEZA' },
      { text: 'RECEPCIONISTA', value: 'AEROPREMIER' },
      { text: 'SUPERVISOR DE SEGURIDAD', value: 'SUPERVISOR DE SEGURIDAD' },
    ],
    motivo_disabled: true,
    editcolaborador: false,
    valid: true,
    btnuploadfiles: false,
    btnaddfiles: true,
    btnsubmitfiles: true,
    processing: false,
    text_required_rules: [
      v => !!v || 'Requerido',
    ],
    nameRules: [
      v => !!v || 'Nombre es requerido',
    ],
    apellidoRules: [
      v => !!v || 'Apellido es requerido',
    ],
    emailRules: [
      v => !!v || 'Correo electrónico requerido',
      v => /.+@.+/.test(v) || 'Correo electrónico no válido',
    ],
    rfcRules: [
      v => !!v || 'Requerido',
      v => /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/.test(v) || 'RFC no válido',
    ],
    codigoPostalRules: [
      v => !!v || 'Requerido',
      v => /^([0-9]{5,6})$/.test(v) || 'Código postal de 5 a 6 dígitos',
    ],
    phoneRules: [
      v => !!v || 'Requerido',
      v => (v && v.length === 10) || 'Número de 10 dígitos',
    ],
    primer_nombre: '',
    segundo_nombre: '',
    primer_apellido: '',
    segundo_apellido: '',
    sexo: '',
    fecha_nacimiento: '',
    nacionalidad: '',
    originario: '',
    estado_civil: '',
    rfc: '',
    nss: '',
    domicilio: '',
    colonia: '',
    ciudad: '',
    estado: '',
    codigo_postal: '',
    telefono: '',
    celular: '',
    numero_empleado: '',
    credencial: '',
    email: '',
    status: 'inactivo',
    empresa: '',
    grupo: '',
    fecha_contratacion: '',
    gerencia: '',
    gerencia_desde: '',
    frente: '',
    frente_desde: '',
    puesto: '',
    puesto_desde: '',
    periodo_pago: '',
    periodo_pago_desde: '',
    colaborador_id: '',
    curp: '',
    observaciones: '',
    huella_imagen: '',
    huella_template: '',
    signatures: [],
    files: [],
    captures: [],
    foto: [],
    firma: [],
    imgWidth: 0,
    imgHeight: 0,
    credential_dialog: false,
    vigencia_credencial: '',
    motivo: '',
    player: null,
  }),
  computed: {
    formTitle() {
      return this.editcolaborador === false ? 'Agregar Colaborador' : 'Editar Colaborador';
    },
    is_loading() {
      return this.$store.getters['capturaColaboradores/is_loading'];
    },
    colaborador_submited() {
      return this.$store.getters['capturaColaboradores/colaborador_submited'];
    },
    alertType() {
      return this.$store.getters['capturaColaboradores/alertContainerType'];
    },
    alertMessage() {
      return this.$store.getters['capturaColaboradores/alertContainerMessage'];
    },
    alert() {
      return this.$store.getters['capturaColaboradores/alertContainer'];
    },
    alertDialogType() {
      return this.$store.getters['capturaColaboradores/alertDialogType'];
    },
    alertDialogMessage() {
      return this.$store.getters['capturaColaboradores/alertDialogMessage'];
    },
    alertDialog() {
      return this.$store.getters['capturaColaboradores/alertDialog'];
    },
    colaborador_processing() {
      return this.$store.getters['capturaColaboradores/colaborador_processing'];
    },
  },
  watch: {
    colaborador_processing(val) {
      this.processing = val;
    },
  },
  methods: {
    back() {
      this.$router.back();
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    clear_null(value) {
      let tmp = null;
      if (typeof value === 'string') {
        tmp = value.trim();
      } else if (value === null || typeof value === 'undefined') {
        tmp = '';
      } else {
        tmp = value;
      }
      return tmp;
    },
    send_form() {
      if (this.processing === true) {
        return;
      }
      if (this.$refs.form.validate()) {
        this.$store.commit('capturaColaboradores/startedColaboradorProcessing');
        const formdata = new FormData();
        formdata.set('primer_nombre', this.clear_null(this.primer_nombre));
        formdata.set('segundo_nombre', this.clear_null(this.segundo_nombre));
        formdata.set('primer_apellido', this.clear_null(this.primer_apellido));
        formdata.set('segundo_apellido', this.clear_null(this.segundo_apellido));
        formdata.set('sexo', this.clear_null(this.sexo));
        formdata.set('fecha_nacimiento', this.clear_null(this.fecha_nacimiento));
        formdata.set('nacionalidad', this.clear_null(this.nacionalidad));
        formdata.set('originario', this.clear_null(this.originario));
        formdata.set('estado_civil', this.clear_null(this.estado_civil));
        formdata.set('rfc', this.clear_null(this.rfc));
        formdata.set('nss', this.clear_null(this.nss));
        formdata.set('domicilio', this.clear_null(this.domicilio));
        formdata.set('colonia', this.clear_null(this.colonia));
        formdata.set('ciudad', this.clear_null(this.ciudad));
        formdata.set('estado', this.clear_null(this.estado));
        formdata.set('codigo_postal', this.clear_null(this.codigo_postal));
        formdata.set('telefono', this.clear_null(this.telefono));
        formdata.set('celular', this.clear_null(this.celular));
        formdata.set('numero_empleado', this.clear_null(this.numero_empleado));
        formdata.set('credencial', this.clear_null(this.credencial));
        formdata.set('email', this.clear_null(this.email));
        formdata.set('status', this.clear_null(this.status));
        formdata.set('motivo', this.clear_null(this.motivo));
        formdata.set('empresa', this.clear_null(this.empresa));
        formdata.set('grupo', this.clear_null(this.grupo));
        formdata.set('fecha_contratacion', this.clear_null(this.fecha_contratacion));
        formdata.set('gerencia', this.clear_null(this.gerencia));
        formdata.set('gerencia_desde', this.clear_null(this.gerencia_desde));
        formdata.set('frente', this.clear_null(this.frente));
        formdata.set('frente_desde', this.clear_null(this.frente_desde));
        formdata.set('puesto', this.clear_null(this.puesto));
        formdata.set('puesto_desde', this.clear_null(this.puesto_desde));
        formdata.set('periodo_pago', this.clear_null(this.periodo_pago));
        formdata.set('periodo_pago_desde', this.clear_null(this.periodo_pago_desde));
        formdata.set('curp', this.clear_null(this.curp));
        formdata.set('observaciones', this.clear_null(this.observaciones));
        formdata.set('vigencia_credencial', this.clear_null(this.vigencia_credencial));
        formdata.set('acceso_lunes', this.clear_null(this.colaborator_hours.lunes.acceso));
        formdata.set('acceso_martes', this.clear_null(this.colaborator_hours.martes.acceso));
        formdata.set('acceso_miercoles', this.clear_null(this.colaborator_hours.miercoles.acceso));
        formdata.set('acceso_jueves', this.clear_null(this.colaborator_hours.jueves.acceso));
        formdata.set('acceso_viernes', this.clear_null(this.colaborator_hours.viernes.acceso));
        formdata.set('acceso_sabado', this.clear_null(this.colaborator_hours.sabado.acceso));
        formdata.set('acceso_domingo', this.clear_null(this.colaborator_hours.domingo.acceso));
        formdata.set('hora_entrada_lunes', this.clear_null(this.colaborator_hours.lunes.hora_entrada));
        formdata.set('hora_entrada_martes', this.clear_null(this.colaborator_hours.martes.hora_entrada));
        formdata.set('hora_entrada_miercoles', this.clear_null(this.colaborator_hours.miercoles.hora_entrada));
        formdata.set('hora_entrada_jueves', this.clear_null(this.colaborator_hours.jueves.hora_entrada));
        formdata.set('hora_entrada_viernes', this.clear_null(this.colaborator_hours.viernes.hora_entrada));
        formdata.set('hora_entrada_sabado', this.clear_null(this.colaborator_hours.sabado.hora_entrada));
        formdata.set('hora_entrada_domingo', this.clear_null(this.colaborator_hours.domingo.hora_entrada));
        formdata.set('hora_salida_lunes', this.clear_null(this.colaborator_hours.lunes.hora_salida));
        formdata.set('hora_salida_martes', this.clear_null(this.colaborator_hours.martes.hora_salida));
        formdata.set('hora_salida_miercoles', this.clear_null(this.colaborator_hours.miercoles.hora_salida));
        formdata.set('hora_salida_jueves', this.clear_null(this.colaborator_hours.jueves.hora_salida));
        formdata.set('hora_salida_viernes', this.clear_null(this.colaborator_hours.viernes.hora_salida));
        formdata.set('hora_salida_sabado', this.clear_null(this.colaborator_hours.sabado.hora_salida));
        formdata.set('hora_salida_domingo', this.clear_null(this.colaborator_hours.domingo.hora_salida));
        if (this.captures.length !== 0) {
          formdata.set('foto', this.captures[this.captures.length - 1]);
        }
        if (this.signatures.length !== 0) {
          formdata.set('firma', this.signatures[this.signatures.length - 1]);
        }
        if (this.fingerPrint.fingerprint_image.length !== 0) {
          formdata.set('huella_imagen', this.fingerPrint.fingerprint_image);
        }
        if (this.fingerPrint.fingerprint_template.length !== 0) {
          formdata.set('huella_template', this.fingerPrint.fingerprint_template);
        }
        if (this.editcolaborador) {
          formdata.set('colaborador_id', this.colaborador_info.colaborador_id);
        }
        this.$store.commit('capturaColaboradores/resetColaboradorSubmit');
        this.$store.dispatch('capturaColaboradores/sendCollaborator', formdata).then(() => {
          this.$router.back();
        });
      }
    },
    tipo_status_change(event) {
      if (event === 'baja') {
        this.motivo_disabled = false;
      } else {
        this.motivo_disabled = true;
      }
    },
    init_edit_data(data) {
      this.colaborador_id = data.colaborador_id;
      this.primer_nombre = data.primer_nombre;
      this.segundo_nombre = data.segundo_nombre;
      this.primer_apellido = data.primer_apellido;
      this.segundo_apellido = data.segundo_apellido;
      this.sexo = data.sexo;
      this.fecha_nacimiento = data.fecha_nacimiento;
      this.nacionalidad = data.nacionalidad;
      this.originario = data.originario;
      this.estado_civil = data.estado_civil;
      this.rfc = data.rfc;
      this.nss = data.nss;
      this.domicilio = data.domicilio;
      this.colonia = data.colonia;
      this.ciudad = data.ciudad;
      this.estado = data.estado;
      this.codigo_postal = data.codigo_postal;
      this.telefono = data.telefono;
      this.celular = data.celular;
      this.numero_empleado = data.numero_empleado;
      this.credencial = data.credencial;
      this.email = data.email;
      this.status = data.status;
      this.empresa = data.empresa;
      this.grupo = data.grupo;
      this.fecha_contratacion = data.fecha_contratacion;
      this.gerencia = data.gerencia;
      this.gerencia_desde = data.gerencia_desde;
      this.frente = data.frente;
      this.frente_desde = data.frente_desde;
      this.puesto = data.puesto;
      this.puesto_desde = data.puesto_desde;
      this.periodo_pago = data.periodo_pago;
      this.periodo_pago_desde = data.periodo_pago_desde;
      this.curp = data.curp;
      this.observaciones = data.observaciones;
      this.vigencia_credencial = data.vigencia_credencial;
      this.motivo = data.motivo;
      this.asign_colaborator_hours(data);
      if (this.status === 'baja') {
        this.motivo_disabled = false;
      } else {
        this.motivo_disabled = true;
      }
    },
  },
  created() {
  },
  mounted() {
    if ('id' in this.$route.params) {
      this.$store.dispatch('capturaColaboradores/fetchCollaboratorInfo', this.$route.params.id).then((data) => {
        this.colaborador_info = data.colaborador;
        this.init_edit_data(data.colaborador);
      });
      this.editcolaborador = true;
    }
  },
};
</script>
<style type="text/css">

</style>
